export default { ...window.muAppConfigDev };
